import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.salesrep/territory-manager/repgroup/pricelist-picker-table.htm";
//import customerConfig from "emun.customer/customer.config";
//import SalesRepParser from "emun.salesrep/territory-manager/zipcode/parser/zipcode-parser";
//import ApplyTagsPrompt from "emun.customer/picker/apply-retailer-tags-prompt";

//export const filters = customerConfig.filters;

export const views = {
	list: "table",
	//  cards: "th-large"
};

export default class PriceListPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.setListIds();
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
		$ctrl.bus = $ctrl.query.bus;
		//$ctrl.viewSelectionsChanged(); //load()
	}

	templateUrl = () => `pricelist-picker-${this.query.view}.htm`;

	selectAll() {
		const $ctrl = this;
		$ctrl.query.results.forEach(p => ($ctrl.selected[p.id] = true));
		this.setListIds();
	}
	clearAll() {
		this.selected = {};
		this.setListIds();
	}
	canClear() {
		return Object.keys(this.selected).length;
	}

	isSelected(list) {
		return !!this.selected[list.priceListId];
	}

	setListIds() {
		this.listIds = Object.keys(this.selected || {});
	}

	selectionsLabel() {
		const { listIds: keys = [] } = this;
		if (keys.length > 4)
			return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
				4} more...`;
		if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
		return "No selections";
	}

	hasSelections = () => Object.keys(this.selected).length > 0;

	viewSelectionsChanged() {
		const $ctrl = this;
		const idIn = $ctrl.viewSelections
			? Object.keys($ctrl.selected || {}).join(",")
			: null;
		$ctrl.query.clearRefinements(false);
		$ctrl.query.filter("IdIn", idIn);
	}

	toggle(list) {
		const $ctrl = this;
		console.log("toggle", list.priceListId, $ctrl.selected, list);

		if ($ctrl.single) {
			$ctrl.$close(list);
		} else if (list.priceListId in $ctrl.selected) {
			delete $ctrl.selected[list.priceListId];
			$ctrl.onListUnSelected &&
				$ctrl.onListUnSelected({ $list: list, ...$ctrl });
		} else {
			$ctrl.selected[list.priceListId] = true;
			$ctrl.onListSelected &&
				$ctrl.onListSelected({ $list: list, ...$ctrl });
		}
		this.setListIds();
	}
	select(list) {
		const $ctrl = this;
		$ctrl.$close([list]);
	}

	$onDestroy() {
		this.query.dispose();
	}

	//parseZipcodes() {
	//	const $ctrl = this;
	//	ZipcodeParser({}).then(zipcodeIds => {
	//		$ctrl.selected = {};
	//		zipcodeIds.forEach(zipcodeId => {
	//			$ctrl.toggle({ id: zipcodeId });
	//		});
	//		$ctrl.viewSelections = true;
	//		$ctrl.viewSelectionsChanged();
	//	});
	//}

	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryPriceLists.json?GroupBy=PriceListId",
			pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
			views,
			criteria: $ctrl.criteria,
			view: "table",
//			filters,
			sortOptions: {
				"PriceListId": "Id: Low to High",
				"-PriceListId": "Id: High to Low",
			},
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			orderBy: "PriceListId",
			autoLoad: true,
			append: false
		};
	}
}


